<span *ngIf="loading; else deals" class="loading-container">
  <mat-spinner diameter="24" class="loading-deals"></mat-spinner>
  <div class="loading-text">Loading Deals...</div>
</span>

<ng-template #deals>
  <div #dealsTableContainer class="deals-table-container">
    <table
      mat-table
      matSort
      multiTemplateDataRows
      class="deals-table"
      [dataSource]="tableDataSource$ | async"
      [trackBy]="dealTrackBy"
      [matSortActive]="defaultSortColumn"
      [matSortDirection]="defaultSortColumn === 'loopRank' ? 'asc' : 'desc'">

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr
        mat-row
        *matRowDef="let deal; columns: columnsToDisplay;"
        class="deal-row"
        [class.expanded-row]="dealExpanded(deal)"
        [attr.data-deal-id]="deal.id"
        (click)="toggleExpanded(deal)">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'active-tab': !history}"></th>
        <td mat-cell *matCellDef="let deal">
          <mat-icon class="expand-icon">{{ dealExpanded(deal) ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="loopRank">
        <th mat-header-cell
            mat-sort-header
            class="tw-text-right"
            arrowPosition="before"
            *matHeaderCellDef
            [ngClass]="{'active-tab': !history}"
            matTooltip="Lendio Offer Ordering & Prioritization (LOOP) Ranking."
            [matTooltipPosition]="'above'">
          Rank
        </th>
        <td mat-cell
            *matCellDef="let deal">
          <span class="tw-font-bold tw-w-full tw-text-right tw-block">{{ deal.loopRank || '---' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="lenderProduct">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'active-tab': !history}"> Product </th>
        <td mat-cell *matCellDef="let deal">
          <div class="tw-font-bold">{{ deal.loan_product_lender.name }}</div>
          <div class="tw-mt-1">
            <span class="tw-mr-2.5" *ngIf="deal.loan_product.category.shortName; else noProduct">
              {{ getLoanType(deal) }}
              <span *ngIf="!history && (getCountPublishedOffers(deal) | async) as publishedCount" class="published-label">
                ({{ publishedCount }}&nbsp;published)
              </span>
            </span>
            <ng-template #noProduct>—</ng-template>
            <div class="tw-inline-block" *ngIf="deal.isRenewalSubmission">

              <span class="tw-inline-block">
                <svg class="tw-pt-0.5" width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.66667 0C3.90556 0 1.66667 2.23889 1.66667 5H0L2.22222 7.22222L4.44444 5H2.77778C2.77778 2.85 4.51667 1.11111 6.66667 1.11111C8.81667 1.11111 10.5556 2.85 10.5556 5C10.5556 7.15 8.81667 8.88889 6.66667 8.88889C5.82778 8.88889 5.05 8.61667 4.41111 8.16667L3.62222 8.96667C4.46667 9.61111 5.52222 10 6.66667 10C9.42778 10 11.6667 7.76111 11.6667 5C11.6667 2.23889 9.42778 0 6.66667 0Z" fill="#435A88"/>
                </svg>
              </span>
              <span class="tw-text-blue-500">
                {{ 'Renewal' }}
              </span>

            </div>

          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="lender">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'active-tab': !history}"> Lender </th>
        <td mat-cell *matCellDef="let deal">
          <div class="tw-flex tw-justify-between">
            {{ deal.loan_product_lender.name }}
            <span *ngIf="deal.isRenewalSubmission" class="renewal">
              {{ deal.type | titlecase }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="loanProduct">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [ngClass]="{'active-tab': !history}">
          Type
        </th>
        <td mat-cell *matCellDef="let deal">
          <span *ngIf="deal.loan_product.category.shortName; else noProduct">{{ deal.loan_product.category.shortName }}</span>
          <ng-template #noProduct>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="offerAmount" *ngIf="!history">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="active-tab"
          mat-sort-header
          matTooltip="Most recent offer amount"
          matTooltipPosition="above">
          Amount
        </th>
        <td mat-cell *matCellDef="let deal">
          {{ !!deal?.termsValues?.amount ? (deal.termsValues.amount | currency) : '—' }}
          <span *ngIf="!!deal.termsValues?.sourceType">({{ deal.termsValues.sourceType | titlecase }})</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="offerPayback" *ngIf="!history">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="active-tab"
          mat-sort-header
          matTooltip="Most recent offer payback amount"
          matTooltipPosition="above">
          Payback
        </th>
        <td mat-cell *matCellDef="let deal">
          {{ !!deal?.termsValues?.payback ? (deal.termsValues.payback | currency) : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="offerRate" *ngIf="!history">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="active-tab"
          mat-sort-header
          matTooltip="Most recent offer rate"
          matTooltipPosition="above">
          Rate
        </th>
        <td mat-cell *matCellDef="let deal">
          {{ !!deal?.termsValues?.rate ? deal.termsValues.rate : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="offerTerm" *ngIf="!history">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="active-tab"
          mat-sort-header
          matTooltip="Most recent offer term"
          matTooltipPosition="above">
          Term
        </th>
        <td mat-cell *matCellDef="let deal">
          {{ !!deal?.termsValues?.term ? deal.termsValues.term : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="offerFrequency" *ngIf="!history">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="active-tab"
          mat-sort-header
          matTooltip="Most recent offer payment frequency"
          matTooltipPosition="above">
          Freq
        </th>
        <td mat-cell *matCellDef="let deal">
          {{ !!deal?.termsValues?.frequency ? (deal.termsValues.frequency | titlecase ) : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="offerPayment" *ngIf="!history">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="active-tab"
          mat-sort-header
          matTooltip="Most recent offer payment amount"
          matTooltipPosition="above">
          Payment
        </th>
        <td mat-cell *matCellDef="let deal">
          {{ !!deal?.termsValues?.payment ? (deal.termsValues.payment | currency) : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="offerFeesPerDollar" *ngIf="!history">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="active-tab"
          mat-sort-header
          matTooltip="Most recent offer total interest/fees paid per dollar loaned"
          matTooltipPosition="above">
          Fees/{{ currencySymbol }}
        </th>
        <td mat-cell *matCellDef="let deal">
          {{ !!deal?.termsValues?.fees ? (deal.termsValues.fees | currency) : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="offerPoints" *ngIf="!history">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="active-tab"
          mat-sort-header
          matTooltip="Most recent offer points"
          matTooltipPosition="above">
          Pts
        </th>
        <td mat-cell *matCellDef="let deal">
          {{ !!deal?.termsValues?.points ? deal.termsValues.points : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastApplicationDate" *ngIf="history">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Last Submitted </th>
        <td mat-cell *matCellDef="let deal">
          <span>{{ deal.lastApplicationDate | date:'shortDate' }}</span>
        </td>
      </ng-container>


      <ng-container matColumnDef="status">
        <th mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="tw-w-[14rem]"
            [ngClass]="{'active-tab': !history}"> Status </th>
        <td mat-cell *matCellDef="let deal" class="tw-w-[14rem]">

          <!--    readOnly is passed into the component explicitly for compact/simplified views and defaults to false    -->
          <!--    users cannot manually change deal status without the canSeeDealStatusRestrictions permission    -->
          <app-deal-status-picker-smart
            *ngIf="!readOnly && (canSeeDealStatusRestrictions$ | async) else readOnlyStatus"
            [dealId]="deal.id"
            [status]="deal.status"
            [statusOptions]="deal.statusOptions">
          </app-deal-status-picker-smart>
          <ng-template #readOnlyStatus>
            <div class="column-grid" [ngClass]="{'tw-justify-between': showDealsPageLink}">
              <app-deal-status-display [deal]="deal"></app-deal-status-display>
              <div class="tw-grid tw-items-center" *ngIf="showDealsPageLink">
                <a target="_blank" href="/borrower/{{borrowerId}}?pane=deals&subpane=active">
                  <mat-icon>open_in_new</mat-icon>
                </a>
              </div>
            </div>
          </ng-template>
        </td>
      </ng-container>

      <!-- additional columns for history view -->
      <ng-container matColumnDef="reason" *ngIf="history">
        <th mat-header-cell *matHeaderCellDef> Reason </th>
        <td data-cy="inactive-deal-reason" mat-cell *matCellDef="let deal">
          <span *ngIf="deal.stage === 'inactive' && deal.last_inactive_status && deal.last_inactive_status.reason; else noReason" [matTooltip]="getAdditionalInactiveReasons(deal)" matTooltipPosition="above">
            {{ getDealInactiveReason(deal) }}
          </span>
          <ng-template #noReason>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="comment" *ngIf="history">
        <th mat-header-cell *matHeaderCellDef> Comment </th>
        <td mat-cell *matCellDef="let deal">
          <mat-icon *ngIf="deal.stage === 'inactive' && deal.last_inactive_status && deal.last_inactive_status.otherReason"
            [matTooltip]="getDealCommentTooltip(deal)"
            matTooltipClass="reason-tooltip"
            matTooltipPosition="above">
            chat_bubble_outline
          </mat-icon>
        </td>
      </ng-container>


      <ng-container matColumnDef="renewal" *ngIf="history">
        <th mat-header-cell *matHeaderCellDef></th>
        <td data-cy="inactive-deal-renewal" mat-cell *matCellDef="let deal">
          <span *ngIf="deal?.funded_loan_status?.isEligibleForRenewal === 1">
            <mat-chip class="renewal-chip">Ready for Renewal</mat-chip>
          </span>
        </td>
      </ng-container>
      <!-- end additional columns for history view -->


      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let deal" [attr.colspan]="columnsToDisplay.length">
          <div class="deal-detail" [@detailExpand]="dealExpanded(deal) ? 'expanded' : 'collapsed'" [style.height]="dealExpanded(deal) ? 'unset' : '0 !important'">
            <div *ngIf="history; else active">
              <ng-container *ngIf="dealExpanded(deal);">
                <app-deal-smart
                  [deal]="deal"
                  (expand)="!dealExpanded(deal) ? toggleExpanded(deal) : null"
                  (submit)="submit.emit($event)"
                  [bulkSubmitting]="bulkSubmitting"
                  [@detailExpand]="dealExpanded(deal) ? 'expanded' : 'collapsed'">
                </app-deal-smart>
              </ng-container>
            </div>
            <ng-template #active>
              <app-deal-smart
                [bulkSubmitting]="bulkSubmitting"
                [deal]="deal"
                (expand)="!dealExpanded(deal) ? toggleExpanded(deal) : null"
                [readOnly]="readOnly"
                [showDealRightColumn]="showDealRightColumn"
                (submit)="submit.emit($event)">
              </app-deal-smart>
            </ng-template>
          </div>
        </td>
      </ng-container>

    </table>
  </div>
</ng-template>
